import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Card, Typography } from '@mui/material';
import React from 'react';
const headerStyleMap = {
    draft: {
        color: themeColors.accent.blue.bold,
        backgroundColor: themeColors.accent.blue.subtlest,
    },
    closed: {
        color: themeColors.accent.grey.bold,
        backgroundColor: themeColors.accent.grey.subtlest,
    },
    mobilizing: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
    inProgress: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
    complete: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
};
export const MissionBox = ({ headerTitle, missionId, missionStatus, children, additionalHeaderInfo }) => {
    return (React.createElement(Card, { sx: {
            overflow: 'hidden',
            mb: 2,
        }, variant: 'outlined', "data-test": `mission-box-${missionId}` },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'center', sm: 'space-between' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2 },
                p: 2,
                color: headerStyleMap[missionStatus],
            } },
            React.createElement(Typography, { variant: 'overline', "data-test": 'mission-header-title' }, headerTitle),
            additionalHeaderInfo),
        React.createElement(Box, null, children)));
};
